import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]
  static values = {
    scale: { type: Number, default: 2 }
  }

  connect() {
    this.isZoomed = false
    this.isMobile = "ontouchstart" in window
    this.setupStyles()
  }

  disconnect() {
    this.resetZoom()
  }

  setupStyles() {
    // Container needs overflow hidden to clip zoomed image
    this.element.style.overflow = "hidden"
    this.element.style.cursor = "zoom-in"

    // No transition for instant zoom (avoids visual glitches)
    this.imageTarget.style.transformOrigin = "center center"
  }

  enter() {
    if (this.isMobile) return

    this.isZoomed = true
    this.element.style.cursor = "zoom-out"
    this.imageTarget.style.transform = `scale(${this.scaleValue})`
  }

  leave() {
    if (this.isMobile) return

    this.isZoomed = false
    this.element.style.cursor = "zoom-in"
    this.imageTarget.style.transform = "scale(1)"
    this.imageTarget.style.transformOrigin = "center center"
  }

  move(event) {
    if (!this.isZoomed || this.isMobile) return

    const rect = this.element.getBoundingClientRect()

    // Calculate mouse position as percentage of container
    const x = ((event.clientX - rect.left) / rect.width) * 100
    const y = ((event.clientY - rect.top) / rect.height) * 100

    // Move transform origin to follow mouse
    this.imageTarget.style.transformOrigin = `${x}% ${y}%`
  }

  resetZoom() {
    this.isZoomed = false
    if (this.imageTarget) {
      this.imageTarget.style.transform = "scale(1)"
      this.imageTarget.style.transformOrigin = "center center"
    }
  }
}
